import { apiClient } from './apiClient';

const base = '/api/calls';

export const callsService = {
  list: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return apiClient.get(`${base}?${queryParams}`);
  },
  stats: () => apiClient.get(`${base}/stats/summary`),
  start: callData => apiClient.post(`${base}/start`, callData),
  end: callId => apiClient.post(`${base}/${callId}/end`, {}),
  get: callId => apiClient.get(`${base}/${callId}`),
  delete: callId => apiClient.del(`${base}/${callId}`),
};

export default callsService;
